<template>
  <StackLayout class="collabsible">
    <GridLayout 
      class="header" 
      columns="*, 40" 
      role="button"
      tabindex="0"
      :aria-expanded="opened ? 'true' : 'false'"
      :aria-controls="contentId"
      :aria-label="label + (description ? ': ' + description : '')"
      @tap="toggle" 
      @click="toggle"
      @keydown="handleKeydown"
    >
      <StackLayout col="0">
        <Label class="label" :text="label" textWrap />
        <Label textWrap :text="description" v-if="description" />
      </StackLayout>
      <AgIcon 
        :type="opened ? 'chevronUp' : 'chevronDown'" 
        col="1" 
        aria-hidden="true"
      />
    </GridLayout>
    <StackLayout 
      class="content" 
      v-if="opened"
      :id="contentId"
      role="region"
      :aria-labelledby="headerId"
    >
      <slot name="default" />
    </StackLayout>
  </StackLayout>
</template>

<script>
export default {
  model: {
    prop: 'open',
    event: 'open'
  },
  props: {
    label: {
      type: String,
      default: '[label]'
    },
    description: {
      type: String
    },
    open: {
      type: String
    },
    id: {
      type: String
    }
  },
  data() {
    return {
      value: '',
      uid: 'collapsible-' + Date.now() + '-' + Math.floor(Math.random() * 10000)
    };
  },
  computed: {
    contentId() {
      return `collapsible-content-${this.uid}`;
    },
    headerId() {
      return `collapsible-header-${this.uid}`;
    },
    opened () {
      return this.label === this.value
    }
  },
  watch: {
    open: {
      immediate: true,
      handler (to) {
        this.value = to
      }
    },
    value: {
      immediate: true,
      handler (to) {
        this.$emit('open', to)
      }
    }
  },
  methods: {
    toggle () {
      this.value = this.opened ? null : this.label
    },
    handleKeydown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.toggle();
      }
    }
  }
}
</script>

<style scoped lang="scss">

.collabsible {
  background: #eee;

  .header {
    width: 100%;

    .label {
      flex-grow: 1;
      font-family: 'Inter', 'RobotoCondensed-Bold', 'Roboto Condensed';
      font-weight: 600;
      color: #004e9e;
    }

    .icon {

    }
  }
}

.ns-ios,
.ns-android {
  .collabsible {
    border-radius: 6;

    .header {
      padding: 20;
      
      .label {
        font-size: 20;
      }

      .icon {
        margin-left: 20;
      }
    }

    .content {
      margin: 0 20 20 20;
      padding-top: 20;
      border-top-width: 1;
      border-top-style: solid;
      border-top-color: #ccc;
    }
  }
}

.ns-ios .collabsible .header .label {
  font-size: 23;
}

html {
  .collabsible {
    border-radius: 6px;

    .header {
      padding: 20px;
      cursor: pointer;
      
      .label {
        font-size: 20px;
      }

      .icon {
        margin-left: 20px;
      }
    }

    .content {
      margin: 0 20px 20px 20px;
      padding-top: 20px;
      border-top: 1px solid #ccc;
    }
  }
}

</style>
